import { Button, ScaleFade } from "@chakra-ui/react";
import React, { useState } from "react";
import { BsPlusCircle } from "react-icons/bs";
import ButtonWithModalPopup from "../../../shared/components/ButtonWithModalPopup/ButtonWithModalPopup";
import { ViewWrapper } from "../../../shared/components/ViewWrapper/ViewWrapper";
import { WhiteButton } from "../../../shared/components/WhiteButton/WhiteButton";
import { buttonBg } from "../../../shared/constants/views.constant";
import StoryCreator from "./StoryCreator/StoryCreator";
import { StoryList } from "./StoryList/StoryList";

export const StoryPage = () => {
  const [isEmployeeFormVisibile, setIsEmployeeFormVisibile] =
    useState<boolean>(false);
  return (
    <ViewWrapper>
      <ButtonWithModalPopup
        isOpen={isEmployeeFormVisibile}
        onClose={() => setIsEmployeeFormVisibile(false)}
        mv={1}
        btnComponent={() => (
          <Button
            bg={buttonBg}
            borderRadius="25px"
            onClick={() => setIsEmployeeFormVisibile(true)}
            colorScheme="purple"
          >
            <BsPlusCircle />
            &nbsp; Add Story
          </Button>
        )}
        title="Add a new Story"
      >
        <ScaleFade initialScale={0.9} in={true} unmountOnExit>
          <StoryCreator />
        </ScaleFade>
      </ButtonWithModalPopup>
      <StoryList />
    </ViewWrapper>
  );
};
